// Vivid categorical palette shared with the mindmap — ideal for distinguishing
// sibling cells. Reused (not re-declared) per the "reuse before adding" rule.
export { DEPTH_COLORS } from '../Cmarkdownmindmap/mindmap-constants';

// Surface colors, matching the established diagram look (flowchart/mindmap use
// the same fill/text values in their own constants files).
export const NODE_FILL = '#131823';
export const NODE_TEXT = 'rgba(255, 255, 255, 0.85)';
export const SECTION_BODY_FILL = 'rgba(255, 255, 255, 0.02)';

// Squarify layout tuning. The treemap is tiled once into a fixed base box, then
// fitView scales it into each render mode (consistent with flowchart/mindmap).
export const BASE_WIDTH = 960;
export const BASE_HEIGHT = 600;
// Header strip reserved at the top of every section before tiling its children.
export const HEADER_HEIGHT = 24;
// Inner gutter between a section's header/border and its tiled children.
export const SECTION_PADDING = 5;

// Below these rect dimensions a cell hides its label / value to avoid text mush.
export const LABEL_MIN_WIDTH = 36;
export const LABEL_MIN_HEIGHT = 28;
export const VALUE_MIN_HEIGHT = 44;

// React Flow viewport.
export const MIN_ZOOM = 0.2;
export const MAX_ZOOM = 2;
export const FIT_VIEW_DURATION = 420;
export const FIT_VIEW_PADDING = 0.18;

// Hover-dim, matching flowchart/mindmap.
export const DIMMED_OPACITY = 0.25;
export const TRANSITION_DURATION = '150ms';

export const TREEMAP_METRIC_UNIT = 'TOTAL';
export const TREEMAP_BACKGROUND_COLOR = 'rgba(255,255,255,0.03)';
